<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

<div menuSystem [cerrixTab]="tab" (changeEvent)="onMenuItemClick($event)">
    @if (!hideActionBar) {
        <div class="detail-page-action-bar flex-action-bar">
            <!-- This div has to stay, so the workflow area can be placed correctly. -->
            <div></div>

            @if (permissions) {
                <div class="workflow-area">
                    @if (
                        permissions.CanManageEffectivenesses ||
                        permissions.CanScoreEffectivenessesTestPeriod
                    ) {
                        <button class="btn btn-warning" (click)="openModal(testPeriodManager)">
                            <i class="fas fa-business-time me-2"></i>
                            {{ 'advEffControlOverview.manageTestPeriods' | t }}
                        </button>
                    }

                    @if (permissions.CanUseAuditSampler) {
                        <button class="btn btn-info" (click)="openModal(auditSampler)">
                            <i class="fas fa-wrench me-2"></i>
                            {{ 'advEffControlOverview.auditSamplerBtn' | t }}
                        </button>
                    }
                </div>
            }
        </div>
    }
    <div [attr.name]="'advEffControlOverview.menuControl' | t" menuItemId="Control" menuicon="fas fa-shield-alt" menusystemsubmenu>
        <div [attr.name]="'advEffControlOverview.menuLinks' | t" menuItemId="Links" menuicon="fas fa-link" menusystemsubmenu>
            <div
                [attr.name]="'advEffControlOverview.menuTestPlans' | t"
                menuicon="fas fa-shield-alt"
                menuItemId="effectiveness-menu-item"
                menusystemitem
            >
                @if (effectivenessOverviewConfig) {
                    <generic-grouped-list-manager [config]="effectivenessOverviewConfig">
                    </generic-grouped-list-manager>
                } @else {
                    <div class="detail-page-card">
                        <div class="detail-page-card-title">{{ 'advEffControlOverview.testPlansCardTitle' | t }}</div>
                        <div class="detail-page-card-body padded">
                            <div class="fancy-loader submodule"></div>
                        </div>
                    </div>
                }

                <adv-eff-wizard [controlGuid]="id" (reload)="reload()" #testWizard></adv-eff-wizard>

                <ng-template #testPeriodManager>
                    <adv-eff-testperiod-manager
                        [controlGuid]="id"
                        [modalRef]="modalRef"
                        (reload)="reload()"
                        [controlPermissions]="permissions"
                    >
                    </adv-eff-testperiod-manager>
                </ng-template>

                <ng-template #auditSampler>
                    <adv-eff-audit-sampler
                        [modalRef]="modalRef"
                        (reload)="reload()"
                    ></adv-eff-audit-sampler>
                </ng-template>

                @if (id) {
                    <control-detail-overview
                        [ControlGuid]="id"
                        [Label]="'advEffControlOverview.linkedControlLabel' | t"
                        [HideOpenControlButton]="false"
                        [HideControlDetails]="false"
                        [HideDesignScore]="false"
                        [HideEffectivenessScore]="false"
                    >
                    </control-detail-overview>
                }
            </div>
        </div>
        <div [attr.name]="'advEffControlOverview.menuHistory' | t" menuicon="fas fa-history" menuItemId="historymenuitem" menusystemitem>
            <app-history-overview
                [historyDataService]="advancedEffectivenessHistoryDataService"
                [Id]="id"
            >
            </app-history-overview>
        </div>
    </div>
</div>
